import {AppRoutes} from "~/utils/other/AppRoutes";
import {navigateTo} from "#app";
import {companyStore} from "~/store/companyStore";
import {auditLogStore} from "~/store/auditLogStore";

/**
 * FR-002: the Audit Log must not be reachable by typing the URL.
 *
 * The decision comes from the API, not from the role in local state, so a user
 * whose permission was revoked cannot keep the page by holding stale session
 * data. The API enforces every request on its own regardless.
 */
export default defineNuxtRouteMiddleware(async () => {
    // The session (company, token) is kept in the browser's localStorage, which
    // the server cannot read. On a page refresh this ran on the server first,
    // found no company, and sent the admin to /unauthorized. Decide in the
    // browser only; the API still refuses every request without permission.
    if (import.meta.server) return;

    const useCompanyStore = companyStore();
    const useAuditLogStore = auditLogStore();

    const companyId = useCompanyStore.getCompanyId;
    if (!companyId) {
        return navigateTo({path: AppRoutes.Unauthorized, replace: true});
    }

    const permissions = await useAuditLogStore.loadPermissions(companyId);
    if (!permissions.canView) {
        return navigateTo({path: AppRoutes.Unauthorized, replace: true});
    }
})
